class DateTimeHelpers {
  getTodayStr() {
    const now = new Date();
    const d = now.getDate();
    const m = now.getMonth() + 1;
    const y = now.getFullYear();
    return `${y}/${m <= 9 ? `0${m}` : m}/${d <= 9 ? `0${d}` : d}`;
  }
  convertDateToMDY(date) {
    const dateParts = date.split("/");
    return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  }

  //deprecated against `convertDateToIsoDMY`
  convertDateToDMY(date) {
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return `${d <= 9 ? `0${d}` : d}/${m <= 9 ? `0${m}` : m}/${y}`;
  }

  convertDateToUtcDmy(date) {
    const d = date.getUTCDate();
    const m = date.getUTCMonth() + 1;
    const y = date.getUTCFullYear();
    return `${d <= 9 ? `0${d}` : d}-${m <= 9 ? `0${m}` : m}-${y}`;
  }

  convertDateToIsoDMY(date) {
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return `${d <= 9 ? `0${d}` : d}-${m <= 9 ? `0${m}` : m}-${y}`;
  }

  covertDateToJsDate(date) {
    const dateParts = date.toString().split("/");
    const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return dateObject.toISOString();
  }

  getDate(dateString) {
    const date = this.parseLocalISO(dateString);
    return this.convertDateToIsoDMY(date);
  }

  getTime(dateString) {
    const date = this.parseLocalISO(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return `${hours}:${minutes}:${seconds}`;
  }

  getLocalTime(dateString) {
    const date = this.parseLocalISO(dateString);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  formatDateTime(dateString) {
    const date = this.parseLocalISO(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const formattedTime = date
      .toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .toUpperCase();

    return `${day}/${month}/${year} - ${formattedTime}`;
  }

  getTodayStrInYMD() {
    const now = new Date();
    return this.getDateYMD(now);
  }
  getWeekStr() {
    const now = new Date();
    now.setDate(now.getDate() - 7);
    return this.getDateYMD(now);
  }
  getMonthStr() {
    const now = new Date();
    now.setMonth(now.getMonth() - 1);
    return this.getDateYMD(now);
  }
  getSixMonthStr() {
    const now = new Date();
    now.setMonth(now.getMonth() - 6);
    return this.getDateYMD(now);
  }

  getDateYMD(date) {
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return `${y}-${m <= 9 ? `0${m}` : m}-${d <= 9 ? `0${d}` : d}`;
  }

  formatServerTimeSegment(timeString) {
    const [hours, minutes, seconds] = timeString.split(":");
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);
    const timeOptions = {
      hour12: true,
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return date.toLocaleTimeString(undefined, timeOptions).toUpperCase();
  }

  startOfDay(dateString) {
    const d = new Date(dateString);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  endOfDay(dateString) {
    const d = new Date(dateString);
    d.setHours(23, 59, 59, 999);
    return d;
  }

  filterStartTime() {
    const startDate = new Date();
    startDate.setHours(0, 0, 0, 1);
    return startDate;
  }

  filterEndTime() {
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);
    return endDate;
  }

  getMaxDate(date) {
    const maxDate = new Date(date);
    maxDate.setHours(23, 59, 59);
    return new Date(maxDate);
  }

  parseLocalISO(dateString) {
    if (!dateString) return new Date(NaN);
    if (typeof dateString === "string") {
      if (dateString.endsWith("Z")) {
        return new Date(dateString.slice(0, -1));
      }

      const match = dateString.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}):(\d{2}))?$/);
      if (match) {
        const [, day, month, year, hour, minute, second] = match;
        return new Date(year, month - 1, day, hour || 0, minute || 0, second || 0);
      }
    }
    return new Date(dateString);
  }

  formatDateAndTime(dateString) {
    if (!dateString) return "-";
    if (typeof dateString === "string" && dateString.includes(" | ")) return dateString;

    const match = dateString.match(/^(\d{2})\/(\d{2})\/(\d{4}),\s*(\d{2}):(\d{2}):(\d{2})$/);
    let date;
    if (match) {
      const [, day, month, year, hour, minute, second] = match;
      date = new Date(year, month - 1, day, hour, minute, second);
    } else {
      date = this.parseLocalISO(dateString);
    }

    if (isNaN(date)) return "-";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    const formattedTime = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  }

  getStartOfDayISO(date = new Date()) {
    return `${this.getDateYMD(date)}T00:00:00.000Z`;
  }

  getEndOfDayISO(date = new Date()) {
    return `${this.getDateYMD(date)}T23:59:59.999Z`;
  }

  getLocalISOString(date = new Date()) {
    const localISOWithZ = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localISOWithZ.toISOString();
  }

  getLocalISODate(date = new Date()) {
    return this.getLocalISOString(date).slice(0, 10);
  }

  formatISODateToDMY(dateStr) {
    if (!dateStr) return "";
    return dateStr.split("-").reverse().join("/");
  }

  formatDMYToISODate(dateStr) {
    if (!dateStr) return "";
    return dateStr.split("/").reverse().join("-");
  }

  getLocalDateTimeAsUTCString(dateString) {
    const selectedDate = new Date(dateString);
    const now = new Date();

    selectedDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    const day = String(selectedDate.getDate()).padStart(2, "0");

    const hours = String(selectedDate.getHours()).padStart(2, "0");
    const minutes = String(selectedDate.getMinutes()).padStart(2, "0");
    const seconds = String(selectedDate.getSeconds()).padStart(2, "0");
    const ms = String(selectedDate.getMilliseconds()).padStart(3, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${ms}Z`;
  }
}

const dateTimeHelpers = new DateTimeHelpers();
export default dateTimeHelpers;
